module.exports = __webpack_public_path__ + "static/media/kitchen2.a409c9fa.jpg";